import { useOutletContext } from 'react-router-dom';
import type { AppOutletContext } from './utils';
import AuthRoute from '@/components/AuthRoute';
import Layout from '@/pages';

export const ProtectedLayoutRoute = () => {
  const { isAuthorized } = useOutletContext<AppOutletContext>();
  return (
    <AuthRoute isAuthorized={isAuthorized}>
      <Layout />
    </AuthRoute>
  );
};
